<script lang="ts" setup>
import { computed } from 'vue'
import { GlobalOutlined } from '@ant-design/icons-vue'
import { useLocaleStore } from '@/store'
import type { LocaleType } from '@/store/locale'

const localeStore = useLocaleStore()

const currentLabel = computed(() => {
  return localeStore.locale === 'zh-CN' ? '中' : 'EN'
})

function handleSelect({ key }: { key: string }) {
  localeStore.setLocale(key as LocaleType)
}
</script>

<template>
  <a-dropdown placement="bottomRight" :trigger="['click']">
    <div class="language-switcher">
      <GlobalOutlined class="language-icon" />
      <span class="language-label">{{ currentLabel }}</span>
    </div>
    <template #overlay>
      <a-menu :selectedKeys="[localeStore.locale]" @click="handleSelect">
        <a-menu-item key="zh-CN">中文</a-menu-item>
        <a-menu-item key="en-US">English</a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<style scoped lang="less">
.language-switcher {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 0 8px;
  height: 100%;
  font-size: 14px;
  user-select: none;

  &:hover {
    opacity: 0.8;
  }
}

.language-icon {
  font-size: 16px;
}

.language-label {
  font-weight: 500;
}
</style>
